import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import routes from '../../../routes';

import {
  exchangeCodeForTokenAction,
  beginAjaxCallAction,
  endAjaxCallAction,
} from '../../../actions/app.action';
import {
  igIntegrationSuccessTitle,
  igIntegrationErrorTitle,
  igSupportEmail,
} from '../../../constants/configuration';
import celebrationBanner from '../../../assets/images/celebration-banner.png';
import crossIcon from '../../../assets/images/cross-black.png';
import fudrOrangeIcon from '../../../assets/images/fudr-orange-logo.png';
import errorIcon from '../../../assets/images/error-icon.png';

import './InstagramHandler.scss';

const InstagramHandler = ({
  code,
  params,
  history,
  exchangeCodeForToken,
  beginAjaxCall,
  endAjaxCall,
}) => {
  const [isFetching, setIsFetching] = useState(false);
  const [showSuccessIntegrationSection, setShowSuccessIntegrationSection] = useState(false);
  const [showErrorIntegrationSection, setShowErrorIntegrationSection] = useState(false);
  const [userDetails, setUserDetails] = useState({});

  const handleInstagramAuth = async () => {
    try {
      const response = await exchangeCodeForToken(code);
      const longLivedToken = get(response, 'data.access_token', '');
      const user_details = get(response, 'data.user_details', {});

      if (longLivedToken) {
        setShowSuccessIntegrationSection(true);
        setUserDetails(user_details);
      } else {
        setShowErrorIntegrationSection(true);
        setShowSuccessIntegrationSection(false);
      }
    } catch (error) {
      console.error('Error during Instagram authentication:', error);
    } finally {
      endAjaxCall();
    }
  };

  useEffect(() => {
    let code = params.get('code');
    const match = code && code.match(/[\?&]code=([^&#]*)/);
    if (match) {
      code = match[1];
    }
    if (!code) {
      // Convert passed `params` to URLSearchParams
      const queryParams = new URLSearchParams(params);

      // Construct the final query string
      const queryString = queryParams.toString();

      // Redirect to the new path with filtered params
      const pageUID = crypto.randomUUID();
      const redirectionUrl = `${window.location.origin}/${routes.containers.view}/${routes.view.instagram}?${queryString}&view=pre-signin&uid=${pageUID}`;
      window.location.replace(redirectionUrl);
    } else {
      // Ensure API is called only once
      if (!isFetching) {
        setIsFetching(true);
        beginAjaxCall();
        // If code exists, run the OAuth flow
        handleInstagramAuth();
      }
    }
  }, [params, history]);

  const renderSection = () => {
    let section = null;
    if (showSuccessIntegrationSection) {
      section = (
        <>
          <img
            src={celebrationBanner}
            alt="Celebration Banner"
            className="instagram-handler_section_image"
          />
          <div className="instagram-handler_section_title">{igIntegrationSuccessTitle}</div>
          {!isEmpty(userDetails) && (
            <div className="instagram-handler_section_profile-details">
              <div className="instagram-handler_section_profile-details_section">
                <img src={fudrOrangeIcon} alt={'Fudr'} />
              </div>
              <div className="instagram-handler_section_profile-details_cross-icon">
                <img src={crossIcon} alt="X" />
              </div>
              <div className="instagram-handler_section_profile-details_section">
                <img src={get(userDetails, 'profile_picture_url')} alt={get(userDetails, 'name')} />
              </div>
            </div>
          )}
          {igSupportEmail && (
            <div className="instagram-handler_section_error-description">
              Kindly reach out to us at
              <br />
              <a href={`mailto:${igSupportEmail}`}>{igSupportEmail} </a>
              for further communication.
            </div>
          )}
        </>
      );
    } else if (showErrorIntegrationSection) {
      section = (
        <>
          <img src={errorIcon} alt="Error Iocn" className="instagram-handler_section_image" />
          <div className="instagram-handler_section_title">{igIntegrationErrorTitle}</div>
          {igSupportEmail && (
            <div className="instagram-handler_section_description">
              Kindly reach out to us at
              <br />
              <a href={`mailto:${igSupportEmail}`}>{igSupportEmail} </a>
              for further assistance.
            </div>
          )}
        </>
      );
    }
    return section;
  };

  return (
    <div className="instagram-handler">
      <div className="instagram-handler_section">{renderSection()}</div>
    </div>
  );
};

const mapDispatchToProps = {
  exchangeCodeForToken: exchangeCodeForTokenAction,
  beginAjaxCall: beginAjaxCallAction,
  endAjaxCall: endAjaxCallAction,
};

export default connect(null, mapDispatchToProps)(InstagramHandler);
